import { render, staticRenderFns } from "./index.vue?vue&type=template&id=35ab51d4&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=35ab51d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ab51d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/erp-flexible-web21_zo1Z/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35ab51d4')) {
      api.createRecord('35ab51d4', component.options)
    } else {
      api.reload('35ab51d4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=35ab51d4&scoped=true&", function () {
      api.rerender('35ab51d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/YTag/index.vue"
export default component.exports